module.exports = __webpack_public_path__ + "img/arrow-right.88f4d7d7.svg";